<template>
  <TermsPage type="brands" name="Brands" :slug="$route.params.slug">
    <template #header>
      <LayoutFeedHeader>
        <template #default>
          {{ name }}
        </template>
        <template #after-heading>
          <p v-if="description" class="mt-4 text-xs">{{ description }}</p>
        </template>
      </LayoutFeedHeader>
    </template>
  </TermsPage>
</template>

<script setup lang="ts">
import type { QueryBrands } from "~/@types/brands"
import { findBrandBySlug } from "~/groq/brands"

const route = useRoute()

const { data } = await useSanityQuery<QueryBrands>(findBrandBySlug(), {
  slug: route.params.slug,
})

if (!data.value) {
  throw showError({
    statusCode: 404,
    statusMessage: "Page not found",
  })
}

const { name, description } = useBrand(data.value)
</script>
